<template>
  <div class="lmaesBanner">
    <div class="center">
      <div class="banner-overlay1">
        <span class="title">MoPaaS 大模型应用引擎RAG+Agent</span>
      </div>
    </div>

  </div>
</template>

<script>
  export default {
    name: 'LmAesBanner',
  }
</script>

<style scoped>
@media(min-width:992px) {
  .lmaesBanner {
    width: 100%;
    height: 20.83vw;
    margin-top: 72px;
    overflow-y: hidden;
    background-image: url("../assets/images/lmaesbanner.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    display: flex;
    align-items: center;
  }
  .lmaesBanner .center {
    width: auto !important;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    padding-left: 10vw;
  }

  .lmaesBanner .banner-overlay1 {
    color: #FFFFFF;
    text-align: left;
  }


  .lmaesBanner .banner-overlay1 .title {
    width: auto;
    font-size: 50px;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 63px;
    display: inline-block;
  }
}
@media(max-width:992px) {
}
</style>
<style></style>


// WEBPACK FOOTER //
// src/components/LmAesBanner.vue